function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgLeaveVideoCall(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 30,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Circle, {
    r: 13.287,
    transform: "matrix(-1 0 0 1 14.877 14.287)",
    stroke: props.color,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M5.155 23.686L23.952 4.889",
    stroke: props.color,
    strokeWidth: 2
  }));
}

export default SvgLeaveVideoCall;